module.exports = __webpack_public_path__ + "static/img/tup7.a6bba8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/tup7.png
// module id = ddt+
// module chunks = 0